<template>
    <div>
        <h1 class="display-heading mb-3">Staff Management</h1>

        <!-- Form -->
        <form @submit.prevent="validate">
            <div class="form-group">
                <label>Name</label>
                <input type="text" name="name" data-vv-validate-on="blur" data-vv-as="name"
                    placeholder="Name" v-model="staff.name" v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('name')
                }">
                <div v-show="validationErrors.has('name')" class="invalid-feedback">
                    {{ validationErrors.first('name') }}
                </div>
            </div>

            <!-- <div class="form-group">
                <label>Email Address</label>
                <input type="text" name="email" placeholder="Email" v-validate="'required'" v-model="staff.email" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('email')
                }">
                <div v-show="validationErrors.has('email')" class="invalid-feedback">
                    {{ validationErrors.first('email') }}
                </div>
            </div> -->

            <div class="form-group">
                <label>Username</label>
                <input type="text" name="username" data-vv-validate-on="blur"
                    data-vv-as="username" placeholder="Username"
                    v-model="staff.username" v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('username')
                }">
                <div v-show="validationErrors.has('username')" class="invalid-feedback">
                    {{ validationErrors.first('username') }}
                </div>
            </div>

            <template v-if="isCreateForm">
                <div class="form-group">
                    <label>Password</label>
                    <input type="password" name="password" data-vv-validate-on="blur"
                        data-vv-as="password" placeholder="Password"
                        v-model="staff.password" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('password')
                    }">
                    <div v-show="validationErrors.has('password')" class="invalid-feedback">
                        {{ validationErrors.first('password') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Password Confirmation</label>
                    <input type="password" name="passwordConfirmation" data-vv-validate-on="blur"
                        data-vv-as="password confirmation" placeholder="Password Confirmation"
                        v-model="staff.passwordConfirmation" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('passwordConfirmation')
                    }">
                    <div v-show="validationErrors.has('passwordConfirmation')" class="invalid-feedback">
                        {{ validationErrors.first('passwordConfirmation') }}
                    </div>
                </div>
            </template>

            <div class="form-group">
                <label>Role</label>
                <select name="role" data-vv-validate-on="blur" data-vv-as="role"
                    v-model="staff.role" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('role')
                }">
                    <template v-for="(role, index) in roles">
                        <option
                            :key="index"
                            :value="role.value"
                            :selected="role.value == staff.role"
                        >
                            {{role.text}}
                        </option>
                    </template>
                </select>
                <div v-show="validationErrors.has('role')" class="invalid-feedback">
                    {{ validationErrors.first('role') }}
                </div>
            </div>
        </form>

        <!-- Form Errors -->
        <p v-if="formHasError" class="text-danger">
            {{formErrorMessage}}
        </p>

        <!-- Submit Button -->
        <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="submit">
            Submit
        </button>

        <!-- Modals -->
        <popup-modal
            ref="popupModalSuccess"
            :hasCloseButton="false"
            :title="submitSuccess ? 'Complete!' : 'Loading...'"
        >
            <template slot="content">
                <template v-if="submitSuccess">
                    <div>
                        <p>{{ isCreateForm ? 'Staff Created.' : 'Staff updated' }}</p>
                        <p>Please click 'Okay' to continue.</p>
                    </div>
                </template>
                <template v-else>
                    <p>Please wait while we are processing your request...</p>
                </template>
            </template>
            <template v-if="submitSuccess" slot="footer">
                <button @click="redirect" class="btn btn-primary btn-primary-insv">
                    Okay
                </button>
            </template>
        </popup-modal>

        <popup-modal ref="popupRegistrationError" :hasCloseButton="false" :title="isCreateForm ? 'Error Creating New Staff.' : 'Error Updating Staff'">
            <template slot="content">
                <p>{{createStaff.errorMessage}}</p>
                <ul>
                    <li v-for="(error, key) in createStaff.errors" :key="key">
                        {{error}}
                    </li>
                </ul>
            </template>
            <template slot="footer">
                <button @click="dismissCreateError" class="btn btn-primary btn-primary-insv">Try Again</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';

export default {
    'components': {
        popupModal
    },
    data () {
        return {
            'isCreateForm': true,
            'staff': {
                'name': null,
                // 'email': null,
                'username': null,
                'role': 0,
                'password': null,
                'passwordConfirmation': null
            },
            'formHasError': false,
            'formErrorMessage': '',
            'submitSuccess': false,
            'createStaff': {
                'errorMessage': '',
                'errors': []
            },
            'roles': [
                {
                    'value': 0,
                    'text': 'Doctor'
                },
                {
                    'value': 1,
                    'text': 'Nurse'
                }
            ]
        };
    },
    mounted () {
        if (this.$route.params.id) {
            this.isCreateForm = false;
            this.axios.get(`/Clinic/GetStaff/${this.$route.params.id}`).then(response => {
                // this.staff.email = response.data.data.e;
                this.staff.name = response.data.data.n;
                this.staff.username = response.data.data.u;
                this.staff.role = response.data.data.r;
            }).catch(error => {
                this.createStaff.errorMessage = error.response.data.message;
                this.$refs.popupRegistrationError.show();
            });
        }
    },
    'methods': {
        validate () {
            return this.$validator.validateAll();
        },
        submit () {
            let submitRoute = this.isCreateForm ? 'Clinic/CreateStaff' : `Clinic/UpdateStaff/${this.$route.params.id}`;

            this.validate().then((isValid) => {
                if (isValid) {
                    this.$refs.popupModalSuccess.show().then(() => {
                        this.submitSuccess = false;
                        this.formHasError = false;

                        let payload = {
                            'n': this.staff.name,
                            // 'e': this.staff.email,
                            'u': this.staff.username,
                            'r': this.staff.role
                        };

                        if (this.isCreateForm) {
                            payload.p = this.staff.password;
                            payload.pc = this.staff.passwordConfirmation;
                        }

                        this.axios.post(submitRoute, payload)
                            .then(({ data }) => {
                                this.submitSuccess = true;
                            }).catch((error) => {
                                if (error && error.response && error.response.data) {
                                    this.createStaff.errorMessage = error.response.data.message;
                                    let errorList = this.spreadRegistrationErrors(error.response
                                        .data.data && error.response.data.data.ve ? error
                                            .response.data.data.ve : []);

                                    this.createStaff.errors = errorList;
                                } else {
                                    this.createStaff.errorMessage = 'An error has occured. Please try again.';
                                }
                                this.$refs.popupModalSuccess.hide().then(() => {
                                    this.$refs.popupRegistrationError.show();
                                });
                            });
                    });
                } else {
                    this.formHasError = true;

                    let errorFields = this.$refs.formContainer.querySelectorAll(
                        '.is-invalid');

                    if (errorFields.length > 0) {
                        errorFields[0].focus();
                        this.formErrorMessage = `There's error(s) in the form. Please check the form and try again.`;
                    } else {
                        this.formErrorMessage = `Please confirm that you have read and understood all of our Terms and Conditions and Privacy Policy before continue.`;
                    }
                }
            });
        },
        dismissCreateError (redirect = false) {
            this.$refs.popupRegistrationError.hide().then(() => {
                if (redirect) {
                    this.$router.push({
                        'name': 'clinic-staff-management'
                    });
                }
            });
        },
        spreadRegistrationErrors (errors) {
            let errorList = [];

            let firstLayerErrors = errors.map(e => e.e);

            firstLayerErrors.forEach(err => {
                if (err.length > 0) {
                    errorList.push(...err);
                }
            });

            return errorList;
        },
        redirect () {
            this.$refs.popupModalSuccess.hide().then(() => {
                this.$router.push({
                    'name': 'clinic-staff-management'
                });
            });
        }
    }
};
</script>
